import { render, staticRenderFns } from "./BatchModifyRecords.vue?vue&type=template&id=138f3219&scoped=true"
import script from "./BatchModifyRecords.vue?vue&type=script&lang=js"
export * from "./BatchModifyRecords.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyRecords.vue?vue&type=style&index=0&id=138f3219&prod&scoped=true&lang=css"
import style1 from "./BatchModifyRecords.vue?vue&type=style&index=1&id=138f3219&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f3219",
  null
  
)

export default component.exports